import React, { useState, useEffect } from 'react';
import { Container, Card, Form, Button, Row, Col, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { encryptPassword } from '../utils/auth';
import { FiUser, FiLock, FiSave, FiArrowLeft } from 'react-icons/fi';

const MyAccount = () => {
    const [user, setUser] = useState({ nome: '', email: '' });
    const [passwords, setPasswords] = useState({ senha_atual: '', nova_senha: '', confirmacao: '' });
    const [feedback, setFeedback] = useState({});
    
    useEffect(() => {
        // Load user data from local storage or API
        const storedUser = JSON.parse(localStorage.getItem('user'));
        if (storedUser) {
            setUser({ nome: storedUser.nome, email: '' }); // Email not in localstorage usually? Need to fetch me
            fetchMe();
        }
    }, []);

    const fetchMe = async () => {
        try {
            const response = await api.get('/users/me');
            setUser(response.data);
        } catch (err) {
            console.error("Erro ao buscar dados do usuário", err);
        }
    };

    const handleUpdateProfile = async (e) => {
        e.preventDefault();
        try {
            await api.put('/users/me', user);
            setFeedback({ type: 'success', text: 'Perfil atualizado com sucesso!' });
            // Update local storage
            const stored = JSON.parse(localStorage.getItem('user'));
            localStorage.setItem('user', JSON.stringify({ ...stored, nome: user.nome }));
        } catch (err) {
            setFeedback({ type: 'danger', text: 'Erro ao atualizar perfil.' });
        }
    };

    const handleUpdatePassword = async (e) => {
        e.preventDefault();
        if (passwords.nova_senha !== passwords.confirmacao) {
            setFeedback({ type: 'danger', text: 'As senhas não conferem.' });
            return;
        }
        try {
            await api.post('/users/me/password', { 
                senha_atual: encryptPassword(passwords.senha_atual), 
                nova_senha: encryptPassword(passwords.nova_senha) 
            });
            setFeedback({ type: 'success', text: 'Senha alterada com sucesso!' });
            setPasswords({ senha_atual: '', nova_senha: '', confirmacao: '' });
        } catch (err) {
            setFeedback({ type: 'danger', text: 'Erro ao alterar senha. Verifique a senha atual.' });
        }
    };

    return (
        <Container className="mt-4">
            <div className="d-flex align-items-center mb-4">
                <Button 
                    variant="link" 
                    as={Link} 
                    to="/dashboard" 
                    className="text-decoration-none p-0 mb-2 text-muted"
                >
                    <FiArrowLeft className="me-1" /> Voltar para Dashboard
                </Button>
            </div>              
            <div className="d-flex justify-content-between align-items-center">
                <h2 className="mb-4 fw-bold" style={{ fontFamily: 'Nunito, sans-serif', color: '#006064' }}>
                    Minha conta
                </h2>
            </div>
            {feedback.text && <Alert variant={feedback.type} onClose={() => setFeedback({})} dismissible>{feedback.text}</Alert>}

            <Row className="g-4">
                <Col md={6}>
                    <Card>
                        <Card.Header><FiUser /> Dados Pessoais</Card.Header>
                        <Card.Body>
                            <Form onSubmit={handleUpdateProfile}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nome Completo</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        value={user.nome} 
                                        onChange={e => setUser({...user, nome: e.target.value})} 
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>E-mail</Form.Label>
                                    <Form.Control 
                                        type="email" 
                                        value={user.email} 
                                        placeholder="Atualize seu e-mail"
                                        onChange={e => setUser({...user, email: e.target.value})} 
                                    />
                                </Form.Group>
                                <div className="d-grid gap-2">
                                    <Button variant="success" type="submit" className="fw-bold"><FiSave className="me-2"/> Salvar Alterações</Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={6}>
                    <Card>
                        <Card.Header className="fw-bold"><FiLock className="text-primary me-2"/> Alterar Senha</Card.Header>
                        <Card.Body>
                            <Form onSubmit={handleUpdatePassword}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Senha Atual</Form.Label>
                                    <Form.Control 
                                        type="password" 
                                        value={passwords.senha_atual} 
                                        onChange={e => setPasswords({...passwords, senha_atual: e.target.value})} 
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nova Senha</Form.Label>
                                    <Form.Control 
                                        type="password" 
                                        value={passwords.nova_senha} 
                                        onChange={e => setPasswords({...passwords, nova_senha: e.target.value})} 
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Confirmar Nova Senha</Form.Label>
                                    <Form.Control 
                                        type="password" 
                                        value={passwords.confirmacao} 
                                        onChange={e => setPasswords({...passwords, confirmacao: e.target.value})} 
                                        required
                                    />
                                </Form.Group>
                                <Button variant="success" type="submit" className="fw-bold"><FiSave className="me-2"/> Alterar Senha</Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default MyAccount;